import React, { useMemo, useState, useEffect, useContext } from 'react';
import StickyTitle from '../components/StickyTitle.js';
import { MaterialReactTable } from 'material-react-table';
import NewClientForm from '../components/NewClientForm.js';
import { Button } from '@mui/material';
import axios from 'axios';
import { CSVLink } from "react-csv";
import { useAuth } from '../../AuthContext.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ClientsPage = () => {

  const { userRole } = useAuth()
  const [employee, setEmployee] = useState(true);
  const [totalDebt, setTotalDebt] = useState(0);

  useEffect(() => {
    if (userRole === "manager") {
      setEmployee(false)
    } else {
      setEmployee(true)
    };
  }, [userRole])




  const updateDataAfterDelete = (deletedRowId) => {
    setData((prevData) => prevData.filter((row) => row.id !== deletedRowId));
  };


  const [isNewClientFormOpen, setIsNewClientFormOpen] = useState(false);
  let [selectedRow, setSelectedRow] = useState(null);
  const [selectedRowData, setSelectedRowData] = useState(null);


  const DeleteClient = async (selectedRowId) => {
    try {
      const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}/clients/delete_client`, {
        data: {
          id: selectedRowId
        }
      });
      if (response.status === 200) {
        toast.success(`Client with Id ${selectedRowId} deleted successfully!"`);
        updateDataAfterDelete(selectedRowId)
      } else {
        toast.error(`Error deleting client.`);
      }
    } catch (error) {
      toast.error(`Error deleting client.`);
    }
  };



  // Function to open the form
  const openNewClientForm = () => {
    setIsNewClientFormOpen(true);
    setSelectedRowData(null)
  };

  // Function to close the form
  const closeNewClientForm = () => {
    setIsNewClientFormOpen(false);
  };

  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/clients/all_clients`);
        const responseData = await response.json();
        if (responseData) {
          setData(responseData.client);
        }
      } catch (error) {
        // Handle errors here
        console.error("Error fetching data:", error);
      }
    }

    fetchClients();

  }, [isNewClientFormOpen]);

  useEffect(() => {
    // Calculate the total debt when the data changes
    const calculateTotalDebt = () => {
      const debtSum = data && data.reduce((sum, client) => sum + Number(client.debt), 0);
      setTotalDebt(debtSum);
    };

    calculateTotalDebt();
  }, [data]);

  const columns = useMemo(
    () => [
      {
        accessorKey: 'id', //access nested data with dot notation
        header: 'Client ID',
        size: 100,
        // Cell: ({ cell }) => (
        //   `ARCL00${cell.getValue()}`
        // ),
      },
      {
        accessorKey: 'lponumber', //access nested data with dot notation
        header: 'LPO No.',
        size: 100,
        Cell: ({ cell }) => (
          `${cell.getValue() ? cell.getValue() : "None"}`
        )
      },
      {
        accessorKey: 'firstname', //access nested data with dot notation
        header: 'First Name',
        size: 100,
      },
      {
        accessorKey: 'lastname',
        header: 'Last Name',
        size: 100,
      },
      {
        accessorKey: 'companyname', //normal accessorKey
        header: 'Company Name',
        size: 200,
      },
      // {
      //   accessorKey: 'email',
      //   header: 'Email',
      //   size: 100,
      // },
      // {
      //   accessorKey: 'debt',
      //   header: 'Debt',
      //   size: 100,
      //   Cell: ({ cell }) => (
      //     `${parseFloat(cell.getValue() || 0).toLocaleString()}`
      //   )
      // },
      // {
      //   accessorKey: 'credit',
      //   header: 'Credit',
      //   size: 100,
      //   Cell: ({ cell }) => (
      //     `${parseFloat(cell.getValue() || 0).toLocaleString()}`
      //   )
      // },
      {
        accessorKey: 'totalamount',
        header: 'Total $',
        size: 100,
        Cell: ({ cell }) => (
          `${parseFloat(cell.getValue() || 0).toLocaleString()}`
        )
      },
    ],
    [],
  );

  return (
    <>
      <StickyTitle title="Clients" button_action={openNewClientForm} button="New Client" />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <div className=' px-4 lg:px-16 py-4 lg:py-10 flex flex-col gap-0 overflow-x-auto'>

        <div className="table-filters flex flex-col md:flex-row items-start md:items-center justify-center md:justify-between mt-3 mb-3">
          <div className='text-2xl ml-2 font-bold font-poppins'>All Clients</div>
          {/* <h2 className=' text-end text-sm sm:text-xl text-black'> Total Debt:<span className='ml-1 text-lg md:text-2xl font-bold'>{`QAR ${totalDebt} `}</span></h2> */}
        </div>

        {data ? (<div className="w-full">
          <MaterialReactTable
            // enableRowActions
            enableRowSelection
            columns={columns}
            data={data}
            renderTopToolbarCustomActions={({ table }) => {
              const handleDelete = () => {
                const selectedRows = table.getSelectedRowModel().flatRows;

                if (selectedRows.length === 1) {
                  selectedRow = selectedRows[0];
                  const selectedRowId = selectedRow.original.id;
                  setSelectedRow(selectedRow);
                  alert('Deleting Client with ID: ' + selectedRowId);
                  DeleteClient(selectedRowId)
                } else {
                  alert('Please select a single row to delete.');
                }
              };
              const handleEdit = () => {
                const selectedRows = table.getSelectedRowModel().flatRows;

                if (selectedRows.length === 1) {
                  const selectedRow = selectedRows[0];
                  const selectedRowData = selectedRow.original;
                  setSelectedRowData(selectedRowData);
                  setIsNewClientFormOpen(true); // Open the form
                } else {
                  alert('Please select a single row to Edit.');
                }
              };


              return (
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                  <Button
                    color="error"
                    disabled={!table.getIsSomeRowsSelected()}
                    onClick={handleDelete}
                    variant="contained"
                    sx={employee ? { display: 'none' } : {}}
                  >
                    Delete
                  </Button>
                  <Button
                    color="success"
                    disabled={!table.getIsSomeRowsSelected()}
                    onClick={handleEdit}
                    variant="contained"
                    sx={employee ? { display: 'none' } : {}}
                  >
                    Edit
                  </Button>
                  <Button
                    color="success"
                    variant="contained"
                  >
                    <CSVLink data={data}>Export to CSV</CSVLink>
                  </Button>
                </div>
              );
            }}
          />
        </div>) : (null)}
      </div>

      <NewClientForm isOpen={isNewClientFormOpen} onClose={closeNewClientForm} selectedRowData={selectedRowData} />
    </>
  );
};

export default ClientsPage;
